__webpack_require__.p = "/fsquared-applet/";